// fi-1432 tutorial registry — maps a short id to a canned fleet-assistant
// message and (optionally) a "home route" the app should be on before
// the walk-through starts. consumed by the markdown renderer, which
// converts [Show me](tutorial:id) links into pill buttons, and by a
// global click handler in app.vue that dispatches them.
//
// to add a tutorial:
//   1. register its id below with the message fleet assistant should type
//      and the route it should run on (null = any page is fine).
//   2. reference it from markdown via [Show me](tutorial:<id>).
//
// ids are kebab-case, letters/numbers/dashes/underscores only — matches
// the markdown_renderer regex gate that accepts tutorial: schemes.

export const TUTORIALS = {
  // notification center
  'notifications-center': {
    message: 'Tell me about the notification center.',
    home_route: '/notifications',
  },
  'create-announcement': {
    message: 'Can you show me how to create and publish an announcement?',
    home_route: '/help_center',
  },

  // actuals / reports — CM and TBN have separate route components, so
  // each tutorial declares the CM route + a home_route_tbn fallback for
  // tenants of type TBN. launchTutorial picks the right one based on the
  // caller's isTbn flag.
  'driver-payroll': {
    message: 'Can you walk me through the Driver Payroll report? Explain each column and how to export.',
    // note: the real "Driver Payroll" report lives under the payroll_summary
    // routes. the similarly-named /actuals_driver_payroll_report path is a
    // legacy filename — it actually renders the Driver Daily Report.
    home_route: '/actuals_payroll_summary_report',
    home_route_tbn: '/actuals_payroll_summary_report_tbn',
  },
  'otp-by-driver': {
    message: 'Can you walk me through the OTP by Driver report?',
    home_route: '/actuals_drivers_daily_report',
  },

  // fleet assistant basics — no home route, runs wherever the user clicked it
  'fleet-assistant-intro': {
    message: 'Can you introduce yourself and show me what you can do?',
    home_route: null,
  },
}

export function getTutorial(id) {
  if (!id) return null
  return TUTORIALS[id] || null
}

// launch a tutorial by id. when the tutorial declares a home_route and
// we're not already under it, push the router there first and wait a
// beat for the destination to mount before firing the launcher. fleet
// assistant launcher is a singleton mounted at app root, so it's
// already listening — the settle delay is for any in-page targets the
// walk-through might want to highlight.
export function launchTutorial(id, { router, root, isTbn } = {}) {
  const cfg = getTutorial(id)
  if (!cfg) {
    try { console.warn('[tutorial] unknown id:', id) } catch (_) {}
    return
  }

  const fire = () => {
    if (root && typeof root.$emit === 'function') {
      root.$emit('open-fleet-assistant-tutorial', { message: cfg.message })
    }
  }

  // pick CM vs TBN route; fall back to home_route when no TBN variant.
  const home_route = (isTbn && cfg.home_route_tbn) ? cfg.home_route_tbn : cfg.home_route
  const currentHash = (window.location.hash || '').replace(/^#/, '') || '/'
  const needsRoute = home_route && !currentHash.startsWith(home_route)

  if (needsRoute && router && typeof router.push === 'function') {
    // settle delay: long enough for route components to mount but short
    // enough that the launcher's halo→open→type sequence feels continuous.
    const settle = () => setTimeout(fire, 250)
    try {
      const navigation = router.push(home_route)
      if (navigation && typeof navigation.then === 'function') {
        navigation.then(settle, settle)
      } else {
        settle()
      }
    } catch (_) {
      settle()
    }
  } else {
    fire()
  }
}
